import React from "react";

import { PureComponent, transformImageUrl } from "@reco-m/core";

export namespace Banner {
    export interface IProps extends PureComponent.IProps {
        bimg?: any;
        cimg?: any;
        cimgShow?: boolean;
        text?: string
    }

    export interface IState extends PureComponent.IState {
        bimg?: string;
        cimg?: string;
        cimgShow?: boolean;
        text?: string
    }

    export class Component<P extends IProps, S extends IState = IState> extends PureComponent.Base<P, S> {
        static defaultProps: any = {
            cimgShow: true,
        };

        render(): React.ReactNode {
            const { bimg, cimg, cimgShow, text } = this.props;

            return (
                <div
                    className="banner-box"
                    style={{
                        // 避免 background 简写在 bimg 变更时冲掉 backgroundSize（书记班子详情会先 zixun 再切 column_banner）
                        backgroundImage: bimg ? `url(${bimg})` : undefined,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    {cimgShow === true ? <img src={transformImageUrl("" + cimg, 100, 100)} alt="" /> : ""}
                    {/* 较长栏目标题缩小字号字距，避免「浦东青年微信公众号热文」等过疏 */}
                    {text && <div className={`banner-text${text.length >= 8 ? " banner-text-compact" : ""}`}>{text}</div>}
                </div>
            );
        }
    }
}
